import * as styles from "./DialogBody.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DialogBodyProps } from "./Dialog.types";

export function DialogBody({
  className,
  ...props
}: DialogBodyProps): JSX.Element {
  return (
    <div
      data-slot="dialog-body"
      className={clsx(styles.body, className)}
      {...props}
    />
  );
}
